
import { createBrowserRouter } from "react-router";
import { appRoutes } from "../routes";

export const routerProvider = createBrowserRouter(appRoutes);


